import {jwtDecode} from 'jwt-decode';
import {Injectable} from '@angular/core';
import {VerificationToken} from '../models/signup.models';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  decodeToken(token: string): VerificationToken {
    return jwtDecode<VerificationToken>(token);
  }

  getCustomClaim(token: string, claimKey: string): string | undefined {
    const decoded = this.decodeToken(token);
    return decoded[claimKey];
  }
}
